import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";

export const setProductDiscount = async (domain: string, productTitle: string, productId: string, variantId: string, discountRate: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop/products/discounts`,
        method: 'PUT',
        params: {
            productTitle, productId: productId.toString(), variantId: variantId.toString(), discountRate
        },
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}